export default __webpack_public_path__ + "static/media/brain.4208dbd7.svg";